class mFaqBar extends window.HTMLDivElement {
    constructor() {
        super();

        this.searchForm = this.querySelector('form');
        this.searchUrl = this.searchForm.action;
        this.searchResultContainer = document.querySelector('#faq-search-form-message');
        this.oFaqGrid = document.querySelector('[is="o-faq-grid"]');
        // Bind this
        this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
        this.searchForm.addEventListener('submit', this.onSubmit);
    }

    onSubmit(e) {
        e.preventDefault();

        fetch(this.searchUrl, {
            method: 'POST',
            body: new FormData(this.searchForm)
        }).then(response => {
            return response.json();
        }).then(response => {
            if (response.success && response.message) {
                this.searchResultContainer.innerHTML = response.message;
                this.oFaqGrid.displaySearchTab();
            }
        });
    }
}

customElements.define('m-faq-bar', mFaqBar, {
    extends: 'div'
});

